// extracted by mini-css-extract-plugin
export default {"footer":"D_bY","row":"D_c7","menuColumn":"D_c8","trademarks":"D_c9"};